<template>
  <div v-loading="loading" class="alarmClass">
    <div style="width:50vw;margin:0 auto;">
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="215px">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="所属项目" prop="projectId">
              <el-select
                 :disabled="model==='view'" 
                v-model="form.projectId"
                style="width: 100%"
                placeholder="所属项目"
                @change="projectIdChange"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="评论积分" prop="evaluationScore">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.evaluationScore"
                placeholder="评论积分"
                maxlength="8"
              ></el-input>  
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="开启订单赠送积分" prop="orderFlag_">
              <el-switch
                v-model="form.orderFlag_"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
          </el-col>
 
          <el-col :span="24">
            <el-form-item label="订单金额赠送积分比例" prop="orderRate">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.orderRate"
                placeholder="订单金额赠送积分比例"
                maxlength="8"
              >
               <template slot="append">%</template>
              </el-input>  
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="订单最大赠送积分" prop="orderMaxScore">
              <el-input
                clearable
                 :disabled="model==='view'" v-model="form.orderMaxScore"
                placeholder="订单最大赠送积分"
                maxlength="8"
              >
              </el-input>  
            </el-form-item>
          </el-col>

        </el-row>
        <div style="text-align: center">
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
            {{ model == 'add' ? '提交' : '修改' }}
          </el-button>
        </div>
      </el-form>
    </div>
    <!-- <div style="text-align: right">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button> -->
      <!-- <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button> -->
    <!-- </div> -->
  </div>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import {
  saveProviderInfo,
  updateProviderInfo,
  saveProviderUserInfo,
  updateProviderUserInfo,
  getMatetial,
  getNursinghome,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
  getNursingList,
  getDeviceTypeList,
  getDeviceModelList,
  saveWristband,
  getBasicInforDetail,
  updateWristband,
  getProviderList,
  saveCommunityInfo,
  updateServiceCommunity,
  saveScoreSetting,
  getScoreSettingDetail
} from '../api/serveItemManage';
import vUpload from "../components/mutil-upload.vue"
import md5 from 'js-md5';
import choicePeople from '@/components/choicePeopleOrDept/choicePeopleInput.vue'
    export default {
  components: {vUpload,choicePeople},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      choicePeopleOption: {
        projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'singlePeople', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 1,
      },
      roleTypeList: [],
      provideList: [
      ],
      providerIdList: [],
      customerTypeList: [{
        name:'新用户',
        id:'1'
      },{
        name:'系统已有用户',
        id:'2'
      }],
      form: {
        projectId:'',
        evaluationScore:'',
        orderFlag:0,
        orderFlag_:true,
        orderRate:'',
        orderMaxScore:'',
      },
      formRules: {
        projectId: [{ required: true, message: '所属项目不能为空', trigger: 'blur' }],
        evaluationScore: [{ required: true, message: '评论积分不能为空', trigger: 'blur' }],
        orderRate: [{ required: true, message: '订单金额赠送积分比例不能为空', trigger: 'blur' }],
        orderMaxScore: [{ required: true, message: '订单最大赠送积分不能为空', trigger: 'blur' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      nursinghomeIdList: [],
      paymentTypeList: [],
      projectList:[],
      typeList:[],
      moduleTypeList:[],
      communityTypeList:[],
      sexList:[{
        dictKey:1,
        dictValue:'男'
      },{
        dictKey:'2',
        dictValue:'女'
      },{
        dictKey:'3',
        dictValue:'未知'
      }]
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    projectIdChange(id){
      this.choicePeopleOption.projectId = id;
      this.form.projectId = id;
      
      this.form = {
        projectId:'',
        evaluationScore:'',
        orderFlag:0,
        orderFlag_:true,
        orderRate:'',
        orderMaxScore:'',
      },
      getScoreSettingDetail({projectId:id}).then(res=>{
        console.log("getScoreSettingDetail==============>",res);
        if(res.data&&(JSON.stringify(res.data)!=="{}")){
          console.log(res.data,res.data+'',JSON.stringify(res.data));
          this.form = res.data;
          if(this.form.orderFlag == 1){
            this.form.orderFlag_ = true;
          }else{
            this.form.orderFlag_ = false;
          }
          this.form = this._.cloneDeep(this.form);
        }else{
          this.form.projectId = id;
          this.form = this._.cloneDeep(this.form);
        }
      });
    },
    customerTypeChange(id){
      this.form.id = '';
      this.choicePeopleOption.selectList = [];
    },
      handlePeople(){
          let idArry = this.form.customerServiceUserIds.split(',')
          let nameArry = this.form.customerServiceUserNames.split(',')
          let length = idArry.length
          for(let i =0;i<length;i++){
              let obj ={
                   id:idArry[i],
                    realName:nameArry[i],
              }
              this.choicePeopleOption.selectList.push(obj)
          }
      },
    //选人组件获取人员后赋值
    getPeople(obj){
        console.log("getPeople==========>",obj);
        let arr = [];
        obj.forEach((ele)=>{
            arr.push(ele.id);
        });
        this.form.userIdList = arr;
        this.form.customerServiceUserIds = arr.join(',');
        this.form.id = arr.join(',');
    //   this.ruleForm.userIds = obj.id
    },
    userIdChange(val){
      let self = this;
      this.userList.forEach(ele=>{
        if(ele.id === val){
          self.form.tel = ele.tel;
          self.form.idNumber = ele.idNumber;
        }
      })
    },
    consumableIdChange() {
      this.form.warehouseList = [];

      if (this.form.consumableId != '') {
        getWarehouseWarnSetting({
          nursinghomeId: this.form.nursinghomeId,
          type: '0',
          consumableId: this.form.consumableId,
        }).then((res) => {
          this.form = res.data;

          this.form.type = 0;
        });
      }
    },
    async initData() {
      
      console.log(this.form,this.model)
      getProjectList().then((res) => {
        this.projectList = res.data;
        getProviderList({projectId:this.row.projectId,status:1}).then((res) => {
          this.providerIdList = res.data;
        });
      });

      this.choicePeopleOption.projectId = this.form.projectId;
          console.log('getBasicInforDetail======================>');
      if(this.model === 'add'){
      }else{
        this.form = this._.cloneDeep(this.row);;
        // this.form.moduleTypesIds = this.form.moduleTypes.split(',');
      }
      // getDictionary('nursinghome_device_category_type').then((res) => {
      //   this.deviceCategoryList = res.data;
      // });
      // getDictionary('nursinghome_payment_type').then((res) => {
      //   this.paymentTypeList = res.data;
      // });
      
      
      // getDictionary('out_order_service_provider_type').then((res) => {
      //   this.typeList = res.data;
      // });
      // getDictionary('out_order_module_type').then((res) => {
      //   this.moduleTypeList = res.data;
      // });
      // getDictionary('out_order_service_provider_user_role_type').then((res) => {
      //   this.roleTypeList = res.data;
      // });
      // getDictionary('out_order_service_community_type').then((res) => {
      //   this.communityTypeList = res.data;
      // });
      
      if (this.model === 'add') {
        // this.form.nursinghomeId = this.nursinghomeId;
        // await getMatetial({ nursinghomeId: this.form.nursinghomeId }).then((res) => {
        //   this.matetialList = res.data;

        //   if (this.matetialList.length > 0) {
        //     this.form.consumableId = this.matetialList[0].id;
        //   }
        // });
        //通过物料id获取仓库数据
        // if (this.form.consumableId != '') {
        //   this.consumableIdChange();
        // }
      } else {
      }
    },
    saveRecord() {
      if(this.form.moduleTypesIds&&this.form.moduleTypesIds.length>0){
        this.form.moduleTypes = this.form.moduleTypesIds.join(',');
      }
      if(this.form.orderFlag_){
        this.form.orderFlag = 1
      }else{
        this.form.orderFlag = 0
      }
      if ((this.model === 'add')) {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            saveScoreSetting(this.form).then((res) => {
              this.$message.success('操作成功');
              this.$emit('success');
            });
          }
        });
      }else{
        
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            saveScoreSetting(this.form).then((res) => {
              this.$message.success('编辑成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
  <style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
  